export const transactionHistoryTranslations = {
  en: {
    'transactionHistory.title': 'Transaction History',
    'transactionHistory.count': '{count} transaction found',
    'transactionHistory.count_plural': '{count} transactions found',
    'transactionHistory.refresh': 'Refresh',
    'transactionHistory.filters': 'Filters',
    'transactionHistory.export': 'Export',
    'transactionHistory.searchPlaceholder': 'Search transactions by description, amount, or recipient...',
    'transactionHistory.filters.title': 'Filters',
    'transactionHistory.filters.description': 'Filter transactions by type, status, and date range',
    'transactionHistory.noRecentActivity': 'No recent activity.',
    'transactionHistory.export.success': 'Export successful',
    'transactionHistory.export.successDesc': 'Transactions exported as {format}',
    'transactionHistory.export.failed': 'Export failed',
    'transactionHistory.export.failedDesc': 'Failed to export transactions',
    'transactionHistory.loading': 'Loading transaction information...',
  },
  es: {
    'transactionHistory.title': 'Historial de Transacciones',
    'transactionHistory.count': '{count} transacción encontrada',
    'transactionHistory.count_plural': '{count} transacciones encontradas',
    'transactionHistory.refresh': 'Actualizar',
    'transactionHistory.filters': 'Filtros',
    'transactionHistory.export': 'Exportar',
    'transactionHistory.searchPlaceholder': 'Buscar transacciones por descripción, cantidad o destinatario...',
    'transactionHistory.filters.title': 'Filtros',
    'transactionHistory.filters.description': 'Filtrar transacciones por tipo, estado y rango de fechas',
    'transactionHistory.noRecentActivity': 'No hay actividad reciente.',
    'transactionHistory.export.success': 'Exportación exitosa',
    'transactionHistory.export.successDesc': 'Transacciones exportadas como {format}',
    'transactionHistory.export.failed': 'Falló la exportación',
    'transactionHistory.export.failedDesc': 'No se pudieron exportar las transacciones',
    'transactionHistory.loading': 'Cargando información de transacciones...',
  },
  fr: {
    'transactionHistory.title': 'Historique des transactions',
    'transactionHistory.count': '{count} transaction trouvée',
    'transactionHistory.count_plural': '{count} transactions trouvées',
    'transactionHistory.refresh': 'Actualiser',
    'transactionHistory.filters': 'Filtres',
    'transactionHistory.export': 'Exporter',
    'transactionHistory.searchPlaceholder': 'Rechercher des transactions par description, montant ou destinataire...',
    'transactionHistory.filters.title': 'Filtres',
    'transactionHistory.filters.description': 'Filtrer les transactions par type, statut et plage de dates',
    'transactionHistory.noRecentActivity': 'Aucune activité récente.',
    'transactionHistory.export.success': 'Exportation réussie',
    'transactionHistory.export.successDesc': 'Transactions exportées au format {format}',
    'transactionHistory.export.failed': 'Échec de l\'exportation',
    'transactionHistory.export.failedDesc': 'Échec de l\'exportation des transactions',
    'transactionHistory.loading': 'Chargement des informations de transaction...',
  },
  sq: {
    'transactionHistory.title': 'Historia e Transaksioneve',
    'transactionHistory.count': '{count} transaksion i gjetur',
    'transactionHistory.count_plural': '{count} transaksione të gjetura',
    'transactionHistory.refresh': 'Rifresko',
    'transactionHistory.filters': 'Filtrat',
    'transactionHistory.export': 'Eksporto',
    'transactionHistory.searchPlaceholder': 'Kërkoni transaksione sipas përshkrimit, shumës ose marrësit...',
    'transactionHistory.filters.title': 'Filtrat',
    'transactionHistory.filters.description': 'Filtroni transaksionet sipas llojit, statusit dhe intervalit të datës',
    'transactionHistory.noRecentActivity': 'Nuk ka aktivitet të fundit.',
    'transactionHistory.export.success': 'Eksportimi i suksesshëm',
    'transactionHistory.export.successDesc': 'Transaksionet u eksportuan si {format}',
    'transactionHistory.export.failed': 'Eksportimi dështoi',
    'transactionHistory.export.failedDesc': 'Dështoi eksportimi i transaksioneve',
    'transactionHistory.loading': 'Duke ngarkuar informacionin e transaksioneve...',
  },
  ru: {
    'transactionHistory.title': 'История транзакций',
    'transactionHistory.count': '{count} транзакция найдена',
    'transactionHistory.count_plural': '{count} транзакций найдено',
    'transactionHistory.refresh': 'Обновить',
    'transactionHistory.filters': 'Фильтры',
    'transactionHistory.export': 'Экспорт',
    'transactionHistory.searchPlaceholder': 'Поиск транзакций по описанию, сумме или получателю...',
    'transactionHistory.filters.title': 'Фильтры',
    'transactionHistory.filters.description': 'Фильтрация транзакций по типу, статусу и диапазону дат',
    'transactionHistory.noRecentActivity': 'Нет недавней активности.',
    'transactionHistory.export.success': 'Экспорт успешен',
    'transactionHistory.export.successDesc': 'Транзакции экспортированы как {format}',
    'transactionHistory.export.failed': 'Экспорт не удался',
    'transactionHistory.export.failedDesc': 'Не удалось экспортировать транзакции',
    'transactionHistory.loading': 'Загрузка информации о транзакциях...',
  },
  pt: {
    'transactionHistory.title': 'Histórico de Transações',
    'transactionHistory.count': '{count} transação encontrada',
    'transactionHistory.count_plural': '{count} transações encontradas',
    'transactionHistory.refresh': 'Atualizar',
    'transactionHistory.filters': 'Filtros',
    'transactionHistory.export': 'Exportar',
    'transactionHistory.searchPlaceholder': 'Buscar transações por descrição, valor ou destinatário...',
    'transactionHistory.filters.title': 'Filtros',
    'transactionHistory.filters.description': 'Filtrar transações por tipo, status e intervalo de datas',
    'transactionHistory.noRecentActivity': 'Nenhuma atividade recente.',
    'transactionHistory.export.success': 'Exportação bem-sucedida',
    'transactionHistory.export.successDesc': 'Transações exportadas como {format}',
    'transactionHistory.export.failed': 'Exportação falhou',
    'transactionHistory.export.failedDesc': 'Falha ao exportar transações',
    'transactionHistory.loading': 'Carregando informações de transações...',
  },
  el: {
    'transactionHistory.title': 'Ιστορικό Συναλλαγών',
    'transactionHistory.count': '{count} συναλλαγή βρέθηκε',
    'transactionHistory.count_plural': '{count} συναλλαγές βρέθηκαν',
    'transactionHistory.refresh': 'Ανανέωση',
    'transactionHistory.filters': 'Φίλτρα',
    'transactionHistory.export': 'Εξαγωγή',
    'transactionHistory.searchPlaceholder': 'Αναζήτηση συναλλαγών κατά περιγραφή, ποσό ή παραλήπτη...',
    'transactionHistory.filters.title': 'Φίλτρα',
    'transactionHistory.filters.description': 'Φιλτράρισμα συναλλαγών κατά τύπο, κατάσταση και εύρος ημερομηνιών',
    'transactionHistory.noRecentActivity': 'Δεν υπάρχει πρόσφατη δραστηριότητα.',
    'transactionHistory.export.success': 'Η εξαγωγή ολοκληρώθηκε με επιτυχία',
    'transactionHistory.export.successDesc': 'Οι συναλλαγές εξήχθησαν ως {format}',
    'transactionHistory.export.failed': 'Η εξαγωγή απέτυχε',
    'transactionHistory.export.failedDesc': 'Αποτυχία εξαγωγής συναλλαγών',
    'transactionHistory.loading': 'Φόρτωση πληροφοριών συναλλαγών...',
  },
  de: {
    'transactionHistory.title': 'Transaktionsverlauf',
    'transactionHistory.count': '{count} Transaktion gefunden',
    'transactionHistory.count_plural': '{count} Transaktionen gefunden',
    'transactionHistory.refresh': 'Aktualisieren',
    'transactionHistory.filters': 'Filter',
    'transactionHistory.export': 'Exportieren',
    'transactionHistory.searchPlaceholder': 'Transaktionen nach Beschreibung, Betrag oder Empfänger suchen...',
    'transactionHistory.filters.title': 'Filter',
    'transactionHistory.filters.description': 'Transaktionen nach Typ, Status und Datumsbereich filtern',
    'transactionHistory.noRecentActivity': 'Keine kürzlichen Aktivitäten.',
    'transactionHistory.export.success': 'Export erfolgreich',
    'transactionHistory.export.successDesc': 'Transaktionen als {format} exportiert',
    'transactionHistory.export.failed': 'Export fehlgeschlagen',
    'transactionHistory.export.failedDesc': 'Transaktionen konnten nicht exportiert werden',
    'transactionHistory.loading': 'Transaktionsinformationen werden geladen...',
  },
  ro: {
    'transactionHistory.title': 'Istoric Tranzacții',
    'transactionHistory.count': '{count} tranzacție găsită',
    'transactionHistory.count_plural': '{count} tranzacții găsite',
    'transactionHistory.refresh': 'Actualizare',
    'transactionHistory.filters': 'Filtre',
    'transactionHistory.export': 'Export',
    'transactionHistory.searchPlaceholder': 'Căutare tranzacții după descriere, sumă sau destinatar...',
    'transactionHistory.filters.title': 'Filtre',
    'transactionHistory.filters.description': 'Filtrare tranzacții după tip, status și interval de date',
    'transactionHistory.noRecentActivity': 'Fără activitate recentă.',
    'transactionHistory.export.success': 'Export reușit',
    'transactionHistory.export.successDesc': 'Tranzacții exportate ca {format}',
    'transactionHistory.export.failed': 'Export eșuat',
    'transactionHistory.export.failedDesc': 'Nu s-au putut exporta tranzacțiile',
    'transactionHistory.loading': 'Se încarcă informațiile tranzacțiilor...',
  },
  sr: {
    'transactionHistory.title': 'Историја трансакција',
    'transactionHistory.count': '{count} трансакција пронађена',
    'transactionHistory.count_plural': '{count} трансакција пронађено',
    'transactionHistory.refresh': 'Освежи',
    'transactionHistory.filters': 'Филтери',
    'transactionHistory.export': 'Извоз',
    'transactionHistory.searchPlaceholder': 'Претражите трансакције по опису, износу или примаоцу...',
    'transactionHistory.filters.title': 'Филтери',
    'transactionHistory.filters.description': 'Филтрирајте трансакције по типу, статусу и датумском распону',
    'transactionHistory.noRecentActivity': 'Нема недавних активности.',
    'transactionHistory.export.success': 'Извоз успешан',
    'transactionHistory.export.successDesc': 'Трансакције су извезене као {format}',
    'transactionHistory.export.failed': 'Извоз неуспешан',
    'transactionHistory.export.failedDesc': 'Није успео извоз трансакција',
    'transactionHistory.loading': 'Учитавање информација о трансакцијама...',
  },
  pl: {
    'transactionHistory.title': 'Historia Transakcji',
    'transactionHistory.count': '{count} transakcja znaleziona',
    'transactionHistory.count_plural': '{count} transakcji znalezionych',
    'transactionHistory.refresh': 'Odśwież',
    'transactionHistory.filters': 'Filtry',
    'transactionHistory.export': 'Eksportuj',
    'transactionHistory.searchPlaceholder': 'Szukaj transakcji po opisie, kwocie lub odbiorcy...',
    'transactionHistory.filters.title': 'Filtry',
    'transactionHistory.filters.description': 'Filtruj transakcje według typu, statusu i zakresu dat',
    'transactionHistory.noRecentActivity': 'Brak ostatniej aktywności.',
    'transactionHistory.export.success': 'Eksport zakończony sukcesem',
    'transactionHistory.export.successDesc': 'Transakcje wyeksportowane jako {format}',
    'transactionHistory.export.failed': 'Eksport nie powiódł się',
    'transactionHistory.export.failedDesc': 'Nie udało się wyeksportować transakcji',
    'transactionHistory.loading': 'Ładowanie informacji o transakcjach...',
  },
};
